import React from 'react';

export default () => (
  <svg width="30" height="30" viewBox="-1 -1 32 32" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <rect stroke="#21304A" fill="none" width="30" height="30" rx="5" />
          <path
            d="M10.608 20.616H9.056v-9.44l-2.144 1.792L6 11.896l3.216-2.608h1.392v11.328zm11.808 0h-7.392v-1.488l4.512-4.48c.341-.352.635-.72.88-1.104.245-.384.368-.816.368-1.296 0-.299-.053-.568-.16-.808a1.888 1.888 0 0 0-.432-.616 1.866 1.866 0 0 0-.64-.392 2.243 2.243 0 0 0-.784-.136c-.576 0-1.05.184-1.424.552-.373.368-.608.84-.704 1.416l-1.52-.256c.064-.427.2-.824.408-1.192.208-.368.472-.688.792-.96.32-.272.69-.483 1.112-.632.421-.15.872-.224 1.352-.224.47 0 .92.07 1.352.208.432.139.813.341 1.144.608.33.267.595.603.792 1.008.197.405.296.87.296 1.392 0 .363-.048.699-.144 1.008-.096.31-.227.603-.392.88s-.36.541-.584.792c-.224.25-.459.499-.704.744l-3.68 3.584h5.552v1.392z"
            fill="#000"
          />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/field-number-small.es6.js